export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const navItem = [
  {
    id: "landing-page-main",
    menuItem: "Home",
    path: "/",
  },
  {
    id: "saas",
    menuItem: "Saas Development",
    path: "/saas",
  },
  {
    id: "mentorship",
    menuItem: "Mentorship",
    path: "/mentorship",
  },
  {
    id: "ai-integration",
    menuItem: "AI Integration",
    path: "/ai-integration",
  },
  {
    id: "contact",
    menuItem: "Contact",
    path: "/contact",
  },
];
